












import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class DadosEmail extends Vue {
    get email () {
        return this.$store.state.cotacao.email;
    }

    set email ( value ) {
        this.$store.commit("SET_EMAIL", value);
    }

    get errorEmail () {
        return this.$store.state.errors.email;
    }

    public onChange () {
        this.$store.dispatch("VALIDAR_DADOS")
            .then()
            .catch(() => { return; });
    }
}
